import { $, $$, on } from "../../utils/dom";

const openClass = "-open";

const setOpen = (truncate: HTMLElement, isOpen: boolean) => {
  truncate.classList.toggle(openClass, isOpen);
  $("button", truncate)?.setAttribute("aria-expanded", String(isOpen));
};

export const onContentLoaded = () => {
  const truncates = $$(".m-breadcrumbs__truncate");
  if (!truncates || truncates.length === 0) {
    return;
  }

  truncates.forEach((truncate: HTMLElement) => {
    on($("button", truncate), "click", () => {
      setOpen(truncate, !truncate.classList.contains(openClass));
    });
  });

  on(document, "click", (event: Event) => {
    truncates.forEach((truncate: HTMLElement) => {
      if (
        truncate.classList.contains(openClass) &&
        !truncate.contains(event.target as Node)
      ) {
        setOpen(truncate, false);
      }
    });
  });

  on(document, "keydown", (event: Event) => {
    if ((event as KeyboardEvent).key === "Escape") {
      truncates.forEach((truncate: HTMLElement) => setOpen(truncate, false));
    }
  });
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
